import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Student } from '../models/student.model';

@Injectable({
  providedIn: 'root',
})
export class SuivisService {
  apiUrl = environment.apiUrl;
  response: any;
  responseCad: any;

  constructor(private http: HttpClient) {}

  query(id) {
    const params = new HttpParams().set('query', 'forSuivi');
    //return this.http.get(`${this.apiUrl}/suivis`, { observe: 'response', params: params  });
    return this.http.post(`${this.apiUrl}/suivis`, id, { observe: 'response', params: params });
  }
  find(id): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'find');
    //return this.http.get(`${this.apiUrl}/suivis`, { observe: 'response', params: params  });
    return this.http.post(`${this.apiUrl}/suivis`, id, { observe: 'response', params: params });
  }
  queryStudent(id): Observable<HttpResponse<number[]>> {
    const params = new HttpParams().set('query', 'queryStudent').set('id', id);
    return this.http.get<number[]>(`${this.apiUrl}/suivis`, { observe: 'response', params: params });
  }
  queryEntreprise(id): Observable<HttpResponse<number>> {
    const params = new HttpParams().set('query', 'queryEntreprise').set('id', id);
    return this.http.get<number>(`${this.apiUrl}/suivis`, { observe: 'response', params: params });
  }

  querySuivisForMe(): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'userList');
    const param = {
      id: localStorage.getItem('id'),
    };
    return this.http.post(`${this.apiUrl}/suivis`, param, { observe: 'response', params: params });
  }

  querySuivis(id): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'userList');
    const param = {
      id,
    };
    return this.http.post(`${this.apiUrl}/suivis`, param, { observe: 'response', params: params });
  }

  add(suivis): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'add');
    return this.http.post(`${this.apiUrl}/suivis`, suivis, { observe: 'response', params: params });
  }
  addMission(mission): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'addMission');
    return this.http.post(`${this.apiUrl}/suivis`, mission, { observe: 'response', params: params });
  }

  cloture(suivis): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'cloture');
    return this.http.post(`${this.apiUrl}/suivis`, suivis, { observe: 'response', params: params });
  }
  clotureAction(suivis): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('query', 'clotureAction');
    return this.http.post(`${this.apiUrl}/suivis`, suivis, { observe: 'response', params: params });
  }

  addQualification(student): Observable<HttpResponse<Student>> {
    const params = new HttpParams().set('query', 'addQualification');
    return this.http.post<Student>(`${this.apiUrl}/student`, student, { observe: 'response', params: params });
  }
}
